import React, { useState, useEffect } from "react";
import axiosInstance from "../utills/axiosInstance";
import './Offboarding.css';
import { useNavigate } from "react-router-dom";

const MyOffboardingRequest = () => {
    const [request, setRequest] = useState(null);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        axiosInstance.get(`/api/my-request`)
            .then(res => {
                setRequest(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, []);

    if (loading) return <div className="app-container"><p>Loading...</p></div>;

    if (Object.keys(request).length === 0) {
        return (
            <div className="app-container">
                <div className="header-section">
                    <h2 className="page-title">My Offboarding Request</h2>
                </div>
                <div className="upload-form">
                    <div className="form-section text-center py-10">
                        <p className="text-gray-600 text-lg">No offboarding request submitted yet.</p>
                        <button onClick={() => navigate("/offboarding")} className="btn btn-primary mt-4">
                            Submit Offboarding Request
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const statusColors = {
        "Pending RM Approval": "bg-yellow-100 text-yellow-800",
        "Pending Admin Approval": "bg-blue-100 text-blue-800",
        "Approved": "bg-green-100 text-green-800",
        "Rejected": "bg-red-100 text-red-800"
    };

    return (
        <div className="app-container">
            <div className="header-section">
                <h2 className="page-title">My Offboarding Request</h2>
            </div>

            <div className="upload-form">
                <div className="form-section">
                    <div className="flex justify-between items-center mb-6">
                        <h3 className="section-title">Request Status</h3>
                        <span className={`px-4 py-2 rounded-full text-sm font-semibold ${statusColors[request.status] || "bg-gray-100"}`}>
                            {request.status}
                        </span>
                    </div>

                    <div className="form-grid">
                        <div className="form-group">
                            <label className="form-label">Employee</label>
                            <input value={`${request?.employee?.firstName} ${request?.employee?.lastName} (${request?.employee?.empId})`} disabled className="form-control" />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Reason for Leaving</label>
                            <input value={request.reasonForLeaving + (request.otherReason ? ` - ${request.otherReason}` : "")} disabled className="form-control" />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Last Working Day</label>
                            <input value={new Date(request.lastWorkingDay).toLocaleDateString()} disabled className="form-control" />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Submitted On</label>
                            <input value={new Date(request.submittedAt).toLocaleDateString()} disabled className="form-control" />
                        </div>
                    </div>

                    {request.rmApproved !== null && (
                        <div className="mt-8 p-5 bg-gray-50 rounded-lg border-l-4 border-blue-500">
                            <h4 className="font-semibold text-blue-900">Reporting Manager Decision</h4>
                            <p>Status: <strong className={request.rmApproved ? "text-green-600" : "text-red-600"}>
                                {request.rmApproved ? "Approved" : "Rejected"}
                            </strong></p>
                            {request.rmRemarks && <p className="mt-2 italic">"{request.rmRemarks}"</p>}
                            <p className="text-sm text-gray-600 mt-1">
                                by {request.rmApprovedBy?.firstName} {request.rmApprovedBy?.lastName} on {new Date(request.rmApprovedAt).toLocaleDateString()}
                            </p>
                        </div>
                    )}

                    {request.adminApproved !== null && (
                        <div className="mt-6 p-5 bg-gray-50 rounded-lg border-l-4 border-green-500">
                            <h4 className="font-semibold text-green-900">Final Admin Decision</h4>
                            <p>Status: <strong className={request.adminApproved ? "text-green-600" : "text-red-600"}>
                                {request.adminApproved ? "Approved" : "Rejected"}
                            </strong></p>
                            {request.adminRemarks && <p className="mt-2 italic">"{request.adminRemarks}"</p>}
                            <p className="text-sm text-gray-600 mt-1">
                                by {request.adminApprovedBy?.firstName} {request.adminApprovedBy?.lastName} on {new Date(request.adminApprovedAt).toLocaleDateString()}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MyOffboardingRequest;
